import { render, staticRenderFns } from "./ViewBusinessAdmin.vue?vue&type=template&id=52939b74"
import script from "./ViewBusinessAdmin.vue?vue&type=script&lang=js"
export * from "./ViewBusinessAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports